module.exports = __webpack_public_path__ + "img/logo.c049db3.svg";